import { DischargeReviewComponent } from "projects/reg-hub-client/src/app/orders/discharge-review/discharge-review.component";
import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";

export class DischargeStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Review", content: DischargeReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}